import * as _ from "lodash";
import * as React from "react";
import {WindowKey} from "@bizform/type/model/model/WindowKey.model";
import {ComponentProperties} from "@bizform/type/model/component/Component.model";
import {GridSubject} from "@bizform/type/model/model/Subject.model";
import {
    GridClientPagingKeyConstant,
    GridClientPagingSizeKeyConstant,
    GridCloseActionKeyConstant,
    GridIdKeyConstant,
    GridLinkIdKeyConstant,
    GridOpenActionKeyConstant
} from "@bizform/type/model/component_element/manifest_constant/Grid.constant";
import {DomAttribute} from "@bizform/type/model/dom/DomAttribute.model";
import {BrowserHelper, DomHelper, FunctionHelper, StringHelper} from "@bizform/helper/dist/js/bizflow/helper.min";
import {GridDataService, ProxyBaseClass} from "@bizform/core/dist/js/bizflow/core.min";
import {GridTableColumnsInformation} from "@bizform/type/model/form/Grid.model";


/**
 * 그리드 핼퍼
 * @since 0.0.1
 * @author Heungsoo,Ham
 * @class
 */
@ProxyBaseClass("root")
class GridHelperUtil {
    destroyed: boolean;
    private _fixedHeader: boolean;

    constructor() {
    }

    infoGridContainer(dom: HTMLElement, gridId: string, title: string, elementId?: string, linkId?: string, listId?: string, mode?: string): React.ReactNode {
        if (window[WindowKey.DESIGNMODE]) {
            const {formId} = DomHelper.getInformationFromDom(dom, true);
            return window[WindowKey.DESIGNLIBRARY].GridHandler.infoGridContainer(formId, gridId, title, StringHelper.elementId(elementId), linkId, StringHelper.elementId(listId), mode);
        } else {
            return null;
        }
    }

    indicatorGridContainer(title: string, solo: boolean = false): React.ReactNode {
        if (window[WindowKey.DESIGNMODE]) {
            return window[WindowKey.DESIGNLIBRARY].GridHandler.indicatorGridContainer(title, true);
        } else {
            return null;
        }
    }

    detailContainer(parentDom: HTMLElement, state: any, data: GridSubject, props: ComponentProperties): boolean {
        let func: Function;
        let close: boolean;
        if (state[GridOpenActionKeyConstant].indexOf(data.value) > -1) {
            close = false;
            func = () => {
                const pDoms: Array<HTMLElement> = Array.from(parentDom.querySelectorAll(`[${DomAttribute.GRIDPK}]`));
                let prePk;
                for (const dom of pDoms) {
                    const info = DomHelper.getGridInformationFromDom(dom, null);
                    if (info.containerElementId === props.elementId) {
                        if (!prePk) {
                            prePk = dom.getAttribute(DomAttribute.GRIDPK) || data.containerElementId;
                            if (prePk) {
                                GridDataService.delTemp(data.formId, data[GridIdKeyConstant], data[GridLinkIdKeyConstant], props.elementId, prePk);
                            } else {
                                prePk = true;
                            }
                        }
                        dom.setAttribute(DomAttribute.GRIDPK, data.pk);
                        dom.setAttribute(DomAttribute.GRIDFROM, data.containerElementId);
                    }
                }
                window[WindowKey.APPLIBRARY]["ComponentHandler"].checkCondition(props);
                (func as any).__proto__ = null;
                func = null;
            };
        } else if (state[GridCloseActionKeyConstant].indexOf(data.value) > -1) {
            close = true;
            func = () => {
                const pDoms: Array<HTMLElement> = Array.from(parentDom.querySelectorAll(`[${DomAttribute.GRIDPK}]`));
                for (const dom of pDoms) {
                    const info = DomHelper.getGridInformationFromDom(dom, null);
                    if (info.containerElementId === props.elementId) {
                        dom.setAttribute(DomAttribute.GRIDPK, "");
                        dom.setAttribute(DomAttribute.GRIDPK, "");
                    }
                }
                window[WindowKey.APPLIBRARY]["ComponentHandler"].checkCondition(props, close);
                (func as any).__proto__ = null;
                func = null;
            };
        }
        if (close === true || close === false) {
            GridDataService.bindData(props, data, close, func);
        }
        return close === false ? true : false;
    }

    async highLightFilter(th: Array<HTMLElement>, filters: Array<any>, columns: Array<GridTableColumnsInformation>): Promise<void> {
        if (th && th.length) {
            let hf = [];
            for (let i = 0; i < th.length; i++) {
                let f: HTMLElement = th[i].querySelector("i[bf-data-value]");
                if (f) {
                    f.classList.remove("bf-text-blue9");
                    f.classList.add("bf-text-gray5");
                    f.removeAttribute("title");
                    hf[i] = f;
                }
            }
            if (filters && filters.length) {
                for (let i = 0; i < filters.length; i++) {
                    if (filters[i].value || filters[i].value === 0 || filters[i].value === false) {
                        const idx = _.findIndex(columns, {entityId: filters[i].orgField});
                        if (hf[idx]) {
                            hf[idx].classList.remove("bf-text-gray4");
                            hf[idx].classList.add("bf-text-blue9");
                            hf[idx].title = filters[i].value.toString();
                        }
                    }
                }
            }
        }
    }

    async errorFilter(th: Array<HTMLElement>, entityIdError: Array<string>, columns: Array<GridTableColumnsInformation>): Promise<void> {
        if (th && th.length) {
            let hf = [];
            for (let i = 0; i < th.length; i++) {
                let f: HTMLElement = th[i].querySelector("i[bf-data-value]");
                if (f) {
                    hf[i] = f;
                    hf[i].classList.remove("bf-text-red9");
                    if (hf[i].classList.contains("_bf-text-blue9")) {
                        hf[i].classList.remove("_bf-text-blue9");
                        hf[i].classList.add("bf-text-blue9");
                    }
                    if (hf[i].classList.contains("_bf-text-gray4")) {
                        hf[i].classList.remove("_bf-text-gray4");
                        hf[i].classList.add("bf-text-gray4");
                    }
                }
            }
            for (let i = 0; i < entityIdError.length; i++) {
                if (entityIdError[i]) {
                    const idx = _.findIndex(columns, {entityId: entityIdError[i]});
                    if (hf[idx]) {
                        if (hf[idx].classList.contains("bf-text-blue9")) {
                            hf[idx].classList.remove("bf-text-blue9");
                            hf[idx].classList.add("_bf-text-blue9");
                        }
                        if (hf[idx].classList.contains("bf-text-gray4")) {
                            hf[idx].classList.remove("bf-text-gray4");
                            hf[idx].classList.add("_bf-text-gray4");
                        }
                        hf[idx].classList.add("bf-text-red9");
                    }
                }
            }
        }
    }

    inlineFilter(hasFilter: boolean, table: HTMLElement, filter: HTMLElement, columns: Array<GridTableColumnsInformation>, columnFilter: any): Array<HTMLElement> {
        const th = Array.from(table.querySelector(".p-datatable-thead").querySelectorAll("th"));
        if (th && th.length) {
            for (let i = 0; i < th.length; i++) {
                let f: HTMLElement = th[i].querySelector("i[bf-data-value]");
                if (hasFilter && columns[i] && columns[i].filterable && columns[i].filterOptions && columns[i].filterOptions.length) {
                    if (!th[i].classList.contains("text-left")) {
                        th[i].classList.add("text-left");
                        if (!f) {
                            f = document.createElement("i");
                            f.setAttribute("class", "fas fa-filter p-1 float-right bf-bg-blue1 bf-text-gray5");
                            f.setAttribute("bf-data-value", String(i));
                            f.addEventListener("click", columnFilter);
                            th[i].appendChild(f);
                        }
                    }
                } else if (th[i].classList.contains("text-left")) {
                    th[i].classList.remove("text-left");
                    if (f) {
                        f.removeEventListener("click", columnFilter);
                        DomHelper.purge(th[i].removeChild(f));
                    }
                }
            }
        }
        return th;
    }

    async fixedHeader(value: number, tdStyle: HTMLStyleElement, eId: string, th: Array<HTMLElement>, table: HTMLElement, height: number, init?: boolean): Promise<void> {
        if (th && th.length && height) {
            if (init) {
                if (!this._fixedHeader) {
                    const style = document.createElement("style");
                    style.innerHTML = `
.p-datatable-wrapper[bf-data-fixed-header] {
    height: auto !important;
    overflow: auto;
}
.p-datatable-wrapper[bf-data-fixed-header] .p-datatable {
    border-collapse: collapse;
}
.p-datatable-wrapper[bf-data-fixed-header] .p-datatable-thead {
    text-align:left;
    display: table;
    float: left;
}
.p-datatable-wrapper[bf-data-fixed-header] .p-datatable-thead tr {
    display: table-row;
}
.p-datatable-wrapper[bf-data-fixed-header] .p-datatable-tbody>tr {
    display: table;
    margin-top: -1px;
}
`;
                    document.head.appendChild(style);
                    this._fixedHeader = true;
                }
            } else {
                table.removeAttribute("bf-data-fixed-header");
                if (value) {
                    const tr: Array<HTMLElement> = Array.from(table.querySelectorAll(".p-datatable-tbody>tr"));
                    while (tr.length !== value) {
                        await FunctionHelper.timeout(100);
                    }
                    let innerHTML = `
.p-datatable-wrapper[bf-data-fixed-header="${eId}"] .p-datatable-tbody {
display: block;
overflow-y: auto;
overflow-x: hidden;
float: left;
height: ${height}px;
}`;
                    for (let i = 0; i < th.length - 1; i++) {
                        const w = th[i].clientWidth + "px !important";
                        innerHTML += `
.p-datatable-wrapper[bf-data-fixed-header="${eId}"] .p-datatable-tbody>tr>td:nth-child(${i + 1}), .p-datatable-wrapper[bf-data-fixed-header="${eId}"] .p-datatable-thead>tr>th:nth-child(${i + 1}) {
width: ${w};
min-width: ${w};
max-width: ${w};
}`;
                    }
                    tdStyle.innerHTML = innerHTML;
                    if (tr[0].parentElement.offsetHeight + tr[0].parentElement.scrollHeight > height) {
                        const i = th.length - 1;
                        table.setAttribute("bf-data-fixed-header", eId);
                        let w;
                        let diff = table.clientWidth - th[0].parentElement.offsetWidth;
                        const d = th[i].clientWidth + diff + "px";
                        if (BrowserHelper.isFireFox()) {
                            diff = table.clientWidth - th[0].parentElement.offsetWidth;
                            w = th[i].clientWidth + diff + "px";
                        } else {
                            diff = table.clientWidth - tr[0].parentElement.offsetWidth;
                            w = (tr[0].lastChild as HTMLElement).clientWidth + diff + "px";
                        }
                        tdStyle.innerHTML = innerHTML + `
.p-datatable-wrapper[bf-data-fixed-header="${eId}"] .p-datatable-tbody>tr>td:nth-child(${i + 1}) {
width: ${w};
min-width: ${w};
max-width: ${w};
}
.p-datatable-wrapper[bf-data-fixed-header="${eId}"] .p-datatable-thead>tr>th:nth-child(${i + 1}) {
width: ${d};
min-width: ${d};
max-width: ${d};
}`;
                    }
                }
            }
        }
    }

    setClientPaging(newState: any): number {
        if (newState[GridClientPagingKeyConstant]) {
            return Number(newState[GridClientPagingSizeKeyConstant]) || 10000;
        }
        return 0;
    }

    destruction() {
    }
}

export const GridHelper: GridHelperUtil = new GridHelperUtil();
